<template>
  <div class="newsDetail">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <!-- <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner> -->
    <div
      class="main-content1 pc"
      style="padding-top: 30px; padding-bottom: 30px"
    >
      <div
        style="width: 100%; line-height: 30px; padding: 40px; background: #fff"
      >
        <div class="big-title" style="">
          <div class="big-name" style="">
            <span class="txt" style="font-size: 32px; font-weight: bold">{{
              detail.title
            }}</span>
          </div>
          <div style="margin-top: 20px; letter-spacing: 0px; font-size: 14px">
            <span style="margin-right: 100px"
              >发布时间：{{
                detail.addtime
                  ? parseTime(
                      new Date(Number(detail.addtime + "000")),
                      "{y}-{m}-{d}"
                    )
                  : ""
              }}</span
            >
            <span>作者/编辑：{{ detail.author }}</span>
          </div>
        </div>
        <div v-html="detail.content" style="min-height: 500px"></div>
      </div>
      <!-- <ul>
        <li>
          <a href="#">其他需求</a>
          <p>
            <a href="https://www.baidu.com">其他需求</a>
          </p>
        </li>
      </ul> -->
    </div>
    <div class="main-content1 mobile">
      <div
        style="
          width: calc(100% - 0.2rem);
          line-height: 30px;
          padding: 0.1rem;
          background: #fff;
        "
      >
        <div class="big-title" style="">
          <div class="big-name" style="">
            <span class="txt" style="font-size: 0.2rem; font-weight: bold">{{
              detail.title
            }}</span>
          </div>
          <div style="margin-top: 20px; letter-spacing: 0px; font-size: 14px">
            <span style="margin-right: 0.3rem"
              >发布时间：{{
                detail.addtime
                  ? parseTime(
                      new Date(Number(detail.addtime + "000")),
                      "{y}-{m}-{d}"
                    )
                  : ""
              }}</span
            >
            <span>作者/编辑：{{ detail.author }}</span>
          </div>
        </div>
        <div
          id="detailContent"
          v-html="detail.content"
          style="min-height: 500px; overflow-x: hidden; zoom: 0.8"
        ></div>
      </div>
      <!-- <ul>
        <li>
          <a href="#">其他需求</a>
          <p>
            <a href="https://www.baidu.com">其他需求</a>
          </p>
        </li>
      </ul> -->
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import RightBar from "@/components/rightBar.vue";
import { getmenudetail, newsdetail } from "@/api/common";
import $ from "jquery";
export default {
  name: "new",
  components: { banner, footerBar, headerBar, RightBar },
  data() {
    return {
      showDialog: false,
      activeIndex: "news",
      info: { carousel: "", Mcarousel: "" },
      detail: null,
    };
  },
  mounted() {
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    newsdetail({ id: this.$route.query.id }).then((res) => {
      this.detail = res.data;
      console.log(this.detail)
      this.postMessage(
        this.detail.title,
        this.detail.abstract,
        window.location.href,
        this.detail.images
      );
      // 处理手机端富文本内容
      this.$nextTick(() => {
        $("#detailContent")
          .find("img")
          .each(function (i) {
            $(this).width("100%");
          });
        $("#detailContent")
          .find("span")
          .each(function (i) {
            $(this).width("100%");
            $(this).css("left", "0");
          });
        $("#detailContent")
          .find(".MsoNormalTable")
          .each(function (i) {
            $(this).width("100%");
          });
      });
    });
  },
  methods: {
    handleSelect() {
      console.log(this.activeIndex);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.newsDetail .newImg {
  height: 260px;
}
.newsDetail .lishu {
  font-family: "Microsoft YaHei";
  font-size: 24px;
  position: relative;
}
.newsDetail .new-Bar {
  width: calc(100% / 3 - 20px);
  background: #f1ece6;
  float: left;
  margin-right: 10px;
  margin-bottom: 30px;
}
.newsDetail .new-Bar:nth-child(3n) {
  margin-right: 0;
}
.newsDetail .new-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.newsDetail .videoBar {
  position: relative;
  margin-bottom: 10px;
}
.newsDetail .videoBar-title {
  position: absolute;
  width: 100%;
  bottom: 5px;
  left: 0;
  height: 90%;
  color: #fff;
  text-align: center;
  opacity: 0;
  padding: 5px 0;
  font-size: 12px;
}
.newsDetail .videoBar-title:hover {
  opacity: 1;
  animation: fade-in;
  animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
}
@media screen and (max-width: 600px) {
  .newImg {
    width: 90%;
    margin: 5px auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/detail.vue